import { getCommonListSlice } from '@iconik-io/shared-lib/src/redux/common_list/slice';

import { initialSearchListState } from './initial_state';

export const SEARCH_LIST_NAME = 'search';

/**
 * getCommonListSlice is memoized on the list name, so the first call's initial
 * state wins and any later one is silently ignored. Every consumer of the
 * search list must import the slice from here rather than calling the factory.
 */
export const searchListSlice = getCommonListSlice(
  SEARCH_LIST_NAME,
  initialSearchListState,
);
